import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { connectToStore } from '../../store';
import SessionList from './session-list/SessionList';
import SessionDetails from './session-details/SessionDetails';
import NotFound from '../not-found/NotFound';
import styles from './Sessions.module.scss';

const subRoutes = [
	{
		path: `/`,
		exact: true,
		component: SessionList,
	},
	{
		path: `/details/:id`,
		exact: true,
		component: SessionDetails,
	},
];

function Sessions() {
	const { path } = useRouteMatch();

	return (
		<div className={styles.screen}>
			<Switch>
				{/* Routes */}
				{subRoutes.map((route, index) => (
					<Route key={index} path={`${path}${route.path}`} exact={route.exact}>
						<route.component />
					</Route>
				))}

				{/* 404 */}
				<Route path="*">
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}

export default connectToStore(Sessions);
